import { render, staticRenderFns } from "./AlertWarning.vue?vue&type=template&id=3a46b38d&"
import script from "./AlertWarning.vue?vue&type=script&lang=ts&"
export * from "./AlertWarning.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports